import store from "../../app/redux/store";
import { decodeAuthToken } from "./UtilityHelper";
import { PTL_EDD_ADMIN_ACCESS } from "../pages/ptl-edd-breach/constants";

/*function to fetch logged is user role */
export function getRole() {
    const { roles = [] } = decodeAuthToken(getToken())
    return roles;
}

export function getToken() {
    const globalState = store.getState();
    const accessToken = globalState.user.userInfo.accessToken;
    return accessToken;
}

export function getUserName() {
    const globalState = store.getState();
    const username = globalState.user.userInfo.username;
    return username;
}

export function getAccess() {
    const userToken = decodeAuthToken(getToken())
    return userToken?.accessList || [];
}

export function isAdmin() {
    const roles = getRole();
    const accessList = getAccess();
    const mergedList = [...roles, ...accessList];
    if (mergedList.length > 0 && (mergedList.includes("ROLE_PROSHIPADMIN"))) {
        return true;
    }
    else {
        return false;
    }
}

// Maps URL path prefixes to the access role required
const PATH_ACCESS_MAP = [
    // D2C Freight Pricing Agent (three categories — most specific first).
    // Gating LIVE with the real JWT access flags. Shared routes (/d2c-pricing/new-proposal
    // and /d2c-pricing/resources/*) are intentionally unmapped → the length>0 fallback
    // lets any holder of a D2C flag reach them; the route guards still scope them to the 3.
    { prefix: '/d2c-pricing/sl', access: 'PROPOSAL_CREATE' },
    { prefix: '/d2c-pricing/l1', access: 'PROPOSAL_L1' },
    { prefix: '/d2c-pricing/fh', access: 'PROPOSAL_ADMIN' },
    // D2C
    { prefix: '/d2c/', access: 'B2C_ACCESS' },
    { prefix: '/orders', access: 'B2C_ACCESS' },
    { prefix: '/order-detail', access: 'B2C_ACCESS' },
    { prefix: '/create-order', access: 'B2C_ACCESS' },
    { prefix: '/preview-order', access: 'B2C_ACCESS' },
    { prefix: '/tracking', access: 'B2C_ACCESS' },
    // NDR/NPR
    { prefix: '/ndr-npr/', access: 'NDR' },
    { prefix: '/pending-ndr', access: 'NDR' },
    // Intervention Analytics
    { prefix: '/intervention/', access: 'NDR' },
    // PTL (more specific entry first)
    { prefix: '/ptl/team-master', access: PTL_EDD_ADMIN_ACCESS },
    { prefix: '/ptl/', access: 'PTL_ACCESS' },
    // Appointment Deliveries V2 (more specific entry first)
    { prefix: '/appointments/miss-reasons', access: 'INTERNAL' },
    { prefix: '/appointments/', access: 'PTL_ACCESS' },
    // Weight
    { prefix: '/weight/', access: 'WEIGHT_DESC' },
    { prefix: '/weight-discrepancy', access: 'WEIGHT_DESC' },
    // Tools & PACE
    { prefix: '/tools/reset-terminal-status', access: 'ORDER_TERMINAL_RESET' },
    { prefix: '/tools/', access: 'TOOLS' },
    { prefix: '/propilot', access: 'TOOLS' },
    { prefix: '/pace/', access: 'TOOLS' },
    { prefix: '/shipment-rate-calculator', access: 'TOOLS' },
    { prefix: '/serviceable', access: 'TOOLS' },
    // Courier Config
    { prefix: '/courier-config/', access: 'INTERNAL' },
    // Merchant Config
    { prefix: '/merchant-config/', access: 'INTERNAL' },
    { prefix: '/merchant-step', access: 'SETTINGS' },
    { prefix: '/merchant-preview', access: 'SETTINGS' },
    { prefix: '/setting', access: 'SETTINGS' },
    // Finance
    { prefix: '/finance/', access: 'FINANCE' },
    { prefix: '/wallet', access: 'FINANCE' },
    // Reports
    { prefix: '/reports', access: 'REPORTS' },
    // Masters
    { prefix: '/masters/', access: 'INTERNAL' },
    // Uploads
    { prefix: '/uploads/', access: 'INTERNAL' },
    // Users
    { prefix: '/users/', access: 'USER_SAVE' },
    // Allocation
    { prefix: '/allocation/', access: 'SA' },
    // Admin
    { prefix: '/admin/', access: 'SA' },
]

const ALLOWED_PAGES = ['/change-password', '/notification', '/profile', '/control-tower']

export function hasPageAccess(pathname) {
    if (ALLOWED_PAGES.includes(pathname)) return true

    const accessList = getAccess()
    const match = PATH_ACCESS_MAP.find(entry => pathname.startsWith(entry.prefix) || pathname === entry.prefix)

    if (match && accessList.includes(match.access)) return true

    // Fallback: allow if user has any access (legacy behavior for unmapped pages)
    return accessList.length > 0
}

export function getMerchant() {
    const globalState = store.getState();
    const merchant = globalState.user.userInfo.merchant;
    return merchant;
}
